import { createPortal } from 'react-dom';
import { ReactComponent as CloseIcon } from '@/assets/icons/ri-close-line.svg';
import { ModalConfirmationProps } from '@/components/common/ConfirmationModal/types';

import './index.css';

const ConfirmationModal = ({
	actions,
	show,
	onClose,
	rootId,
	title,
	subtitle,
}: ModalConfirmationProps) => {
	if (!show) {
		return null;
	}

	return createPortal(
		<div className="modal" aria-hidden>
			<div className="confirmation__modal__content" aria-hidden>
				<div className="confirmation__modal__header">
					<div role="button">
						<CloseIcon onClick={onClose} />
					</div>
				</div>
				<div className="text-center">
					<div className="my-4">
						<label className="confirmation__title">{title}</label>
					</div>
					<div className="my-4">
						<label className="confirmation__subtitle">{subtitle}</label>
					</div>
					{actions}
				</div>
			</div>
		</div>,
		document.getElementById(rootId)
	);
};

export default ConfirmationModal;
